export default ({ tabId, type }) => type === 'live' && tabId === 'compose';
